import { render, staticRenderFns } from "./IconSvgSchool.vue?vue&type=template&id=3452d9f5&scoped=true&"
import script from "./IconSvgSchool.vue?vue&type=script&lang=js&"
export * from "./IconSvgSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3452d9f5",
  null
  
)

export default component.exports